module.exports = __webpack_public_path__ + "static/img/zhong1.3d90ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong1.png
// module id = BoDP
// module chunks = 16